export default __webpack_public_path__ + "static/media/right.2a38734f.svg";